import { render } from "./Preschool.vue?vue&type=template&id=63ec415f&scoped=true"
import script from "./Preschool.vue?vue&type=script&lang=js"
export * from "./Preschool.vue?vue&type=script&lang=js"

import "./Preschool.vue?vue&type=style&index=0&id=63ec415f&scoped=true&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ec415f"]])

export default __exports__